module.exports = __webpack_public_path__ + "img/V91.b60e5a2a.jpg";